/* ============================================================
   CLOUT MERCH — MICRO
   Smaczki animacji: FEEDBACK i AFORDANCJA, nie ornament. Każdy efekt
   odpowiada na akcję usera (hover / otwarcie popupu / pojawienie się
   kontrolki) albo UCZY gestu.

   Warstwa NAD quick-view.js: nie dotyka logiki dialogów, historii ani
   add-to-cart. Czyta stan wprost z DOM ([open] na <dialog>, klasa
   aktywnej stopki) i dokłada transformy oraz klasy-triggery dla
   keyframes z critical.css.

   Żelazne zasady:
   - hover wyłącznie pod (hover: hover) and (pointer: fine),
   - wszystko milczy pod prefers-reduced-motion (sprawdzane na żywo,
     nie raz na start — user może przełączyć preferencję w trakcie),
   - piszemy WYŁĄCZNIE transform / translate (kompozytor) i klasy —
     zero szerokości, marginesów i innych właściwości layoutowych,
   - pointermove throttlowany rAF-em, listenery passive,
   - ŻADNA informacja nie zależy od tych animacji (nośnikiem jest
     tekst i stan kontrolek).

   Tu żyją smaczki, które potrzebują JS:
     1. packshot tilt na kartach grida (desktop),
     2. magnetyczne X popupu,
     5. kaskada wejścia kolumny popupu (klasa .qv--enter),
     6. nudge kciuka slide-to-add (mobile, raz na otwarcie),
     9. ping kropki status chipa (jedzie na tej samej .qv--enter).
   Reszta (3 CTA arrow, 4 eyebrow tick, 7 ZOOM brackets, 8 CART,
   10 toast tick) jest czystym CSS-em w critical.css.
   ============================================================ */
(function () {
  'use strict';

  var FINE = window.matchMedia('(hover: hover) and (pointer: fine)');
  var SHEET = window.matchMedia('(max-width: 780px)');
  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)');
  function motionOK() { return !REDUCE.matches; }

  var medias = [].slice.call(document.querySelectorAll('.merch-card__media'));
  var dialogs = [].slice.call(document.querySelectorAll('[data-qv]'));
  if (!medias.length && !dialogs.length) return;

  /* ---------- wspólna pętla dojazdu (lerp) ----------
     Cel ustawia gest, wartości dojeżdżają do niego lerpem, a gdy całość
     spocznie DOKŁADNIE w zerze — styl jest ZDEJMOWANY. Spoczywający
     element nie trzyma ani transformu, ani will-change (13 kart nie może
     trzymać 13 warstw kompozytora). Jedna pętla rAF na element, żywa
     tylko w trakcie gestu i powrotu. */
  function lerper(write, clear) {
    var cur = [0, 0, 0, 0];
    var tgt = [0, 0, 0, 0];
    var raf = 0;
    var EASE = 0.18;

    function step() {
      raf = 0;
      var busy = false;
      var rest = true;
      for (var i = 0; i < 4; i++) {
        var d = tgt[i] - cur[i];
        if (d > 0.02 || d < -0.02) {
          cur[i] += d * EASE;
          busy = true;
        } else {
          cur[i] = tgt[i];
        }
        if (cur[i] !== 0) rest = false;
      }
      if (rest) clear();
      else write(cur);
      if (busy) raf = requestAnimationFrame(step);
    }

    return function (a, b, c, d) {
      tgt[0] = a; tgt[1] = b; tgt[2] = c; tgt[3] = d;
      if (!raf) raf = requestAnimationFrame(step);
    };
  }

  /* ---------- 1. packshot tilt ----------
     Kadr karty delikatnie podąża za kursorem: bliższa krawędź wychodzi
     do przodu (max ~3°), całość dodatkowo przesuwa się o kilka px w tę
     samą stronę — jeden spójny ruch, nie dwa efekty.

     Tilt siedzi na KONTENERZE (.merch-card__media), flipbook na klatkach
     w środku (opacity + step-end) — nic się nie zderza. Touch nie dostaje
     nic (brak hovera = brak intencji), reduced motion też. */
  function initTilt() {
    if (!medias.length || !FINE.matches || !window.PointerEvent) return;
    var MAX = 3; /* stopnie */
    var PUSH = 4; /* px */

    medias.forEach(function (el) {
      var to = lerper(
        function (v) {
          el.style.transform =
            'perspective(900px) rotateX(' + v[0].toFixed(2) + 'deg) rotateY(' + v[1].toFixed(2) +
            'deg) translate3d(' + v[2].toFixed(2) + 'px, ' + v[3].toFixed(2) + 'px, 0)';
        },
        function () {
          el.style.removeProperty('transform');
          el.style.removeProperty('will-change');
        }
      );

      var rect = null;
      var px = 0;
      var py = 0;
      var pend = 0;

      /* jeden odczyt geometrii na klatkę, w tej samej ramce co zapis —
         żadnego layout thrashu (aktywna jest zawsze jedna karta) */
      function aim() {
        pend = 0;
        if (!rect || !rect.width || !rect.height) return;
        var nx = (px - rect.left) / rect.width - 0.5;
        var ny = (py - rect.top) / rect.height - 0.5;
        if (nx > 0.5) nx = 0.5; else if (nx < -0.5) nx = -0.5;
        if (ny > 0.5) ny = 0.5; else if (ny < -0.5) ny = -0.5;
        /* rotateX bierze ny wprost, rotateY przeciwnie do nx — w układzie
           CSS (y w dół) to właśnie "krawędź przy kursorze idzie do przodu" */
        to(ny * 2 * MAX, -nx * 2 * MAX, nx * 2 * PUSH, ny * 2 * PUSH);
      }

      function rest() {
        rect = null; /* zaległy aim() z rAF-a wyjdzie na pustym rect */
        to(0, 0, 0, 0);
      }

      el.addEventListener('pointerenter', function (e) {
        if (e.pointerType === 'touch' || !motionOK()) return;
        rect = el.getBoundingClientRect();
        el.style.willChange = 'transform';
        px = e.clientX;
        py = e.clientY;
        aim();
      });

      el.addEventListener('pointermove', function (e) {
        if (!rect || e.pointerType === 'touch') return;
        px = e.clientX;
        py = e.clientY;
        if (!pend) pend = requestAnimationFrame(aim);
      }, { passive: true });

      /* Klik w kartę otwiera popup (albo — bez JS-a quick-view — nawiguje
         na PDP z morfem view-transition). Kadr musi wtedy wracać na zero,
         a nie zastygać przekrzywiony pod backdropem / w snapshocie. */
      el.addEventListener('pointerdown', rest, { passive: true });
      el.addEventListener('pointerleave', rest);
      el.addEventListener('pointercancel', rest);
    });
  }

  /* ---------- 2. magnetyczne X ----------
     Przycisk zamknięcia wychyla się w stronę zbliżającego się kursora
     (do ~4px w promieniu ~40px) i wraca lerpem. Siła jest dzwonem:
     zero na granicy promienia, maksimum w połowie drogi, znów zero pod
     samym kursorem — dzięki temu nie ma ani skoku na wejściu w promień,
     ani drgania, gdy kursor stoi na środku przycisku. */
  function initMagnet(dlg) {
    if (!FINE.matches || !window.PointerEvent) return;
    var btn = dlg.querySelector('.qv__close');
    var panel = dlg.querySelector('.qv__panel');
    if (!btn || !panel) return;

    var R = 40; /* promień przyciągania */
    var PULL = 4; /* maksymalne wychylenie */
    var appl = [0, 0]; /* aktualnie nałożona translacja */
    var to = lerper(
      function (v) {
        appl[0] = v[0];
        appl[1] = v[1];
        btn.style.translate = v[0].toFixed(2) + 'px ' + v[1].toFixed(2) + 'px';
      },
      function () {
        appl[0] = 0;
        appl[1] = 0;
        btn.style.removeProperty('translate');
      }
    );

    var px = 0;
    var py = 0;
    var pend = 0;

    function aim() {
      pend = 0;
      if (!motionOK()) { to(0, 0, 0, 0); return; }
      var r = btn.getBoundingClientRect();
      if (!r.width) return;
      /* rect jest JUŻ przesunięty — cofamy translację, żeby liczyć od
         pozycji spoczynkowej (inaczej magnes goniłby sam siebie) */
      var dx = px - (r.left + r.width / 2 - appl[0]);
      var dy = py - (r.top + r.height / 2 - appl[1]);
      var d = Math.sqrt(dx * dx + dy * dy);
      if (d > R || d < 0.5) { to(0, 0, 0, 0); return; }
      var k = 4 * PULL * (d / R) * (1 - d / R) / d;
      to(dx * k, dy * k, 0, 0);
    }

    /* pointermove na panelu: zamknięty <dialog> to display:none, więc
       poza otwartym popupem ten listener nie ma jak się odpalić */
    panel.addEventListener('pointermove', function (e) {
      if (e.pointerType === 'touch') return;
      px = e.clientX;
      py = e.clientY;
      if (!pend) pend = requestAnimationFrame(aim);
    }, { passive: true });
    panel.addEventListener('pointerleave', function () { to(0, 0, 0, 0); });
  }

  /* ---------- 5 + 9. kaskada wejścia popupu i ping statusu ----------
     Jedna klasa na dialogu odpala cały stagger kolumny (meta → cena →
     tytuł → size bar → CTA) i JEDEN ping kropki AVAILABLE. Klasa żyje
     tylko przez czas wejścia, więc przełączanie BUY/DETAILS (które ma
     własną animację) nigdy jej nie powtarza. */
  var ENTER = 'qv--enter';
  var ENTER_MS = 820; /* > najdłuższe wejście (ping: .1s delay + .52s) */
  var enterT = 0;

  function enter(dlg) {
    clearTimeout(enterT);
    dlg.classList.remove(ENTER);
    void dlg.offsetWidth; /* restart animacji przy ponownym otwarciu */
    dlg.classList.add(ENTER);
    enterT = setTimeout(function () { dlg.classList.remove(ENTER); }, ENTER_MS);
  }

  function leave(dlg) {
    clearTimeout(enterT);
    enterT = 0;
    dlg.classList.remove(ENTER);
    /* magnes: zamknięcie dialogu (Esc/tło/add) nie odpala pointerleave
       panelu — bez tego X zostawałby przekrzywiony do następnego ruchu */
    var x = dlg.querySelector('.qv__close');
    if (x) x.style.removeProperty('translate');
  }

  /* ---------- 6. slide-to-add nudge (afordancja gestu) ----------
     Gdy stopka ze suwakiem staje się aktywna (mobile), kciuk robi JEDEN
     nudge w prawo ze sprężystym powrotem — pokazuje, że się przesuwa.
     Raz na otwarcie popupu, nigdy w pętli. Instrukcja i tak jest tekstem
     ("Slide to add…"), więc pod reduced motion nic nie ginie.

     Stan jest modułowy, bo quick-view.js trzyma dokładnie JEDEN otwarty
     popup (przełączenie zamyka poprzedni). */
  var NUDGE = 'slide-buy--nudge';
  var nudgeT = 0;
  var nudgeOffT = 0;
  var footObs = null;
  var nudged = null;
  var nudgeThumb = null;

  /* Koniec lekcji: kasuje oba timery, klasę i guard na kciuku.
     Wołane przez timer wygaszający, przez guard (palec na suwaku)
     i przez clearNudge na zamknięciu popupu — zawsze idempotentnie. */
  function killNudge() {
    clearTimeout(nudgeT);
    clearTimeout(nudgeOffT);
    nudgeT = 0;
    nudgeOffT = 0;
    if (nudgeThumb) {
      nudgeThumb.removeEventListener('pointerdown', killNudge);
      nudgeThumb = null;
    }
    if (nudged) { nudged.classList.remove(NUDGE); nudged = null; }
  }

  function clearNudge() {
    if (footObs) { footObs.disconnect(); footObs = null; }
    killNudge();
  }

  function scheduleNudge(slide) {
    /* Guard na CAŁE okno lekcji (oczekiwanie + animacja): pierwsze
       dotknięcie kciuka ubija nudge natychmiast. pointerdown leci PRZED
       klasą --dragging (ta wchodzi dopiero po 5px ruchu), więc animowany
       `translate` nigdy nie składa się z dragowym `transform` z
       quick-view.js — suwak nie odjeżdża od palca. Nie da się tego zrobić
       CSS-em (:active { animation: none }), bo puszczenie palca bez dragu
       zaaplikowałoby animation-name od nowa. */
    nudgeThumb = slide.querySelector('.slide-buy__thumb');
    if (nudgeThumb) {
      nudgeThumb.addEventListener('pointerdown', killNudge, { once: true, passive: true });
    }
    nudgeT = setTimeout(function () {
      nudgeT = 0;
      /* suwak już poszedł do końca — lekcja zbędna */
      if (slide.classList.contains('slide-buy--dragging') ||
          slide.classList.contains('slide-buy--done')) { killNudge(); return; }
      nudged = slide;
      slide.classList.add(NUDGE);
      nudgeOffT = setTimeout(killNudge, 720);
    }, 400);
  }

  function armNudge(dlg) {
    var foot = dlg.querySelector('[data-qv-foot]');
    if (!foot) return;
    var slide = foot.querySelector('.slide-buy');
    if (!slide) return;
    /* produkt bez rozmiarów: stopka jest aktywna od otwarcia */
    if (foot.classList.contains('qv__foot--active')) { scheduleNudge(slide); return; }
    if (!window.MutationObserver) return;
    /* z rozmiarami: czekamy, aż quick-view.js aktywuje stopkę po wyborze */
    footObs = new MutationObserver(function () {
      if (!foot.classList.contains('qv__foot--active')) return;
      footObs.disconnect();
      footObs = null;
      scheduleNudge(slide);
    });
    footObs.observe(foot, { attributes: true, attributeFilter: ['class'] });
  }

  /* ---------- podłączenie do otwarcia popupu ----------
     Bez dotykania quick-view.js: obserwujemy atrybut [open] na dialogach.
     Łapie to każdą ścieżkę otwarcia (klik w kartę, popstate/back-forward)
     i każde zamknięcie (X, Esc, klik w tło, swipe, add-to-cart). */
  function initOpenHooks() {
    if (!dialogs.length) return;
    dialogs.forEach(initMagnet);
    if (!window.MutationObserver) return;

    var obs = new MutationObserver(function (recs) {
      for (var i = 0; i < recs.length; i++) {
        var dlg = recs[i].target;
        if (dlg.open) {
          if (!motionOK()) continue;
          enter(dlg);
          if (SHEET.matches) armNudge(dlg);
        } else {
          leave(dlg);
          clearNudge();
        }
      }
    });
    dialogs.forEach(function (dlg) {
      obs.observe(dlg, { attributes: true, attributeFilter: ['open'] });
    });
  }

  initTilt();
  initOpenHooks();
})();

/* ---------- header: stan po zescrollowaniu ----------
   Fixed header dostaje glass pas (via html.is-scrolled w CSS), gdy strona
   zjedzie z samej góry. rAF-throttled, passive, działa od startu. */
(function () {
  'use strict';
  var queued = false;
  function update() {
    document.documentElement.classList.toggle('is-scrolled', window.scrollY > 16);
    queued = false;
  }
  window.addEventListener('scroll', function () {
    if (!queued) { queued = true; requestAnimationFrame(update); }
  }, { passive: true });
  update();
})();
